module.exports = __webpack_public_path__ + "static/media/ic-office-2.b5436c6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-office-2.svg
// module id = 648
// module chunks = 14